import type { ThemeMode, WorkspaceSection } from "../types";
import { Icon } from "./Icon";

interface AppShellProps {
  children: React.ReactNode;
  theme: ThemeMode;
  activeSection: WorkspaceSection;
  onSectionChange: (section: WorkspaceSection) => void;
  onThemeChange: (theme: ThemeMode) => void;
}

const nav = [
  ["script", "Projects", "projects"],
  ["script", "Scripts", "storyboards"],
  ["image", "Storyboards", "storyboards"],
  ["camera", "Shot List", "storyboards"],
  ["boards", "Characters", "characters"],
  ["mic", "Voices", "voices"],
  ["image", "Locations", "references"],
  ["download", "References", "references"],
  ["settings", "Reports", "storyboards"]
] as const;

const activeNavLabels = ["Projects", "Storyboards", "Characters", "Voices", "References", "Locations"];

export function AppShell({ children, theme, activeSection, onSectionChange, onThemeChange }: AppShellProps) {
  return (
    <div className="app-shell">
      <aside className="sidebar" aria-label="Kinetix workspace navigation">
        <div className="brand">
          <div className="brand-mark">K</div>
          <div>
            <strong>Kinetix</strong>
            <span>Film Suite</span>
          </div>
        </div>

        <nav className="nav-list">
          {nav.map(([icon, label, section]) => (
            <button
              className={activeSection === section && activeNavLabels.includes(label) ? "active" : ""}
              key={label}
              onClick={() => onSectionChange(section)}
              type="button"
            >
              <Icon name={icon} />
              {label}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="settings-row" type="button">
            <Icon name="settings" />
            Settings
          </button>
          <div className="theme-toggle" role="group" aria-label="Theme">
            <button className={theme === "light" ? "active" : ""} onClick={() => onThemeChange("light")} type="button">
              <Icon name="sun" />
              Light
            </button>
            <button className={theme === "dark" ? "active" : ""} onClick={() => onThemeChange("dark")} type="button">
              <Icon name="moon" />
              Dark
            </button>
          </div>
          <div className="profile-row">
            <span>AR</span>
            <div>
              <strong>Avery Reyes</strong>
              <small>Director</small>
            </div>
          </div>
        </div>
      </aside>
      {children}
    </div>
  );
}
